
import React, { Component } from "react"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

export default class RazorpayTest extends Component {
  state = {
    amount: 0,
    razorpay_payment_id: "",
    currency: "INR",
  }

  handleSubmit = async event => {
    event.preventDefault()
    const options = {
      key: process.env.REACT_APP_RZRPAY_KEY,
      amount: 200,
      currency: "INR",
      name: "Test Payment",
      description: "This is a test payment",
      order_id: "order_S1PEHnJYnvhPNP",
      handler: async response => {
        try {
          console.log('response', response);
          
        //   toast.success(res)
        } catch (error) {
          console.log('error', error);
          toast.error(error.response.data.message)
        }
      },
      prefill: {
        name: "Kunal Kumar",
        email: "kunal@example.com",
        contact: "9876543210",
      },
      theme: {
        color: "#F37254",
      },
    }
    const rzp1 = new window.Razorpay(options)
    rzp1.open()
  }

  getRandomNumber = () => {
    return Math.floor(100000 + Math.random() * 900000)
  }

  render() {
    return (
      <div>
        <ToastContainer />
        <form onSubmit={this.handleSubmit}>
          <input
            type="number"
            value={this.state.amount}
            onChange={e => this.setState({ amount: e.target.value })}
          />
          <button type="submit">Pay</button>
        </form>
      </div>
    )
  }
}
